export default __webpack_public_path__ + "static/media/basicdetails-blue.600112fe.svg";